import React, { useState, FC, useRef, useEffect } from "react";
import clsx from "clsx";
import { FaPlus } from "react-icons/fa6";

interface NewAccordion extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  body: React.ReactNode;
  detailClassName?: string;
}

export const Accordion: FC<NewAccordion> = ({
  title,
  body,
  className,
  detailClassName,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState<string>("0px");

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen) {
      setMaxHeight(`${contentRef.current?.scrollHeight}px`);
    } else {
      setMaxHeight("0px");
    }
  }, [isOpen]);

  return (
    <div
      className={clsx("text-xl lg:text-2xl text-black border-gray20 border-b first:border-t ", className)}
      {...props}
    >
      <div
        className="flex items-center justify-between py-2 cursor-pointer border-gray-300"
        onClick={toggleAccordion}
      >
        <div className="flex items-center justify-between w-full">
          <h3 className="text-sm leading-[100%] font-semibold">{title}</h3>
          <div
            className={`text-xl font-semibold rounded-full h-8 w-full min-w-8 max-w-8 flex items-center justify-center bg-white transition-transform ease-in-out duration-300 ${
              isOpen ? "rotate-45" : ""
            }`}
          >
            {/*@ts-ignore*/}
            <FaPlus size={12} />
          </div>
        </div>
      </div>
      <div
        ref={contentRef}
        className={clsx(
          "quiz-description overflow-hidden transition-max-height duration-300 ease-in-out",
          detailClassName
        )}
        style={{ maxHeight }}
      >
        <div
          className={clsx(
            "px-4 py-2 border-gray-300 text-sm leading-6"
          )}
        >
          {body}
        </div>
      </div>
    </div>
  );
};
